import React from "react";
import "../../Components/Menu/Menu.css";

export default function DataController() {
  return (
    <div>
      <h4 className="sub-title">Behandlingsansvarlig </h4>
      <p className="content">
        <p>
          GMG er behandlingsansvarlig for personopplysninger som fremgår av
          disse vilkårene og for eventuelle andre personopplysninger du
          samtykker til å dele i appen.
        </p>
        <p>
          Hvis du har spørsmål til GMGs behandling av personopplysninger, kan du
          kontakte oss på e-postadressen:{" "}
          <a className="mail-lab" href="mailto:hei@bilista.no">
            hei@bilista.no
          </a>
        </p>
      </p>
    </div>
  );
}
